document.addEventListener('DOMContentLoaded', function() {
  function isMobile() {
    return window.innerWidth <= 900;
  }
  function setupTiles() {
    document.querySelectorAll('.icon-tiles__tiles').forEach(function(tilesEl) {
      const sectionId = tilesEl.id.replace('IconTiles-', '');
      const dotsContainer = document.getElementById('IconTilesDots-' + sectionId);
      const tiles = Array.from(tilesEl.children);
      dotsContainer.innerHTML = '';
      if (tiles.length <= 2 || !isMobile()) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';
      // Create dots
      tiles.forEach((tile, idx) => {
        const dot = document.createElement('div');
        dot.className = 'icon-tiles__carousel-dot';
        if (idx === 0) dot.classList.add('icon-tiles__carousel-dot--active');
        dotsContainer.appendChild(dot);
        dot.addEventListener('click', () => {
          const tileWidth = tile.offsetWidth + parseInt(getComputedStyle(tilesEl).gap || 0);
          tilesEl.scrollTo({ left: tileWidth * idx, behavior: 'smooth' });
        });
      });
      // IntersectionObserver to update dots
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = tiles.indexOf(entry.target);
            dotsContainer.querySelectorAll('.icon-tiles__carousel-dot').forEach((dot, i) => {
              dot.classList.toggle('icon-tiles__carousel-dot--active', i === idx);
            });
          }
        });
      }, {
        root: tilesEl,
        threshold: 0.6
      });
      tiles.forEach(tile => observer.observe(tile));
      // Snap to tile on scroll end (for peeking effect)
      let isScrolling;
      tilesEl.addEventListener('scroll', function() {
        window.clearTimeout(isScrolling);
        isScrolling = setTimeout(function() {
          // Find the tile most in view
          let maxVisible = 0, activeIdx = 0;
          tiles.forEach((tile, idx) => {
            const rect = tile.getBoundingClientRect();
            const parentRect = tilesEl.getBoundingClientRect();
            const visible = Math.max(0, Math.min(rect.right, parentRect.right) - Math.max(rect.left, parentRect.left));
            if (visible > maxVisible) {
              maxVisible = visible;
              activeIdx = idx;
            }
          });
          const tileWidth = tiles[0].offsetWidth + parseInt(getComputedStyle(tilesEl).gap || 0);
          tilesEl.scrollTo({ left: tileWidth * activeIdx, behavior: 'smooth' });
        }, 120);
      });
    });
  }
  setupTiles();
  window.addEventListener('resize', function() {
    setupTiles();
  });
}); 